//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import countries from 'i18n-iso-countries';
import englishCountries from 'i18n-iso-countries/langs/en.json';
countries.registerLocale(englishCountries);
export default {
  data() {
    return {
      name: 'Damien',
      typeDisplay: 'Digital Consultant',
      experience: '5+',
      description:
        'He specialises in handcrafted, bespoke websites, with an interest in open source, marketing and ecommerce. Reach out about your fresh new digital presence today.',
      // priceRange: '$$',
      priceRange: undefined,
      url: 'https://daim.dev/',
      email: 'contact@daim.dev',
      phone: undefined,
      city: undefined,
      streetAddress: undefined,
      region: undefined,
      postcode: undefined,
      country: undefined,
    };
  },
  async fetch() {
    const {
      basics: {
        profiles,
        firstname,
        lastname,
        label,
        // email,
        phone,
        location: {
          streetAddress,
          city,
          region,
          countryCode,
          postalcode: postcode,
        },
        summary,
      },
    } = await this.$content('team', 'damien-robinson').fetch();

    const locale = 'en';
    const country = countries.getName(countryCode, locale);
    const data = {
      profiles,
      firstname,
      lastname,
      // email,
      phone,
      label,
      country,
      region,
      city,
      streetAddress,
      postcode,
      summary,
    };
    Object.assign(this.$data, data);
  },
};
